const scriptDataList = []

const tools = {
  // 格式化日期 前台传值方式  引用类.dateFormat(1402233166999,"yyyy-MM-dd hh:mm:ss")
  dateFormat: (date, fmt) => {
    if (date === null || date === undefined || date === '') {
      return ''
    }
    let getDate = new Date(date)
    let o = {
      'M+': getDate.getMonth() + 1,
      'd+': getDate.getDate(),
      'h+': getDate.getHours(),
      'm+': getDate.getMinutes(),
      's+': getDate.getSeconds(),
      'q+': Math.floor((getDate.getMonth() + 3) / 3),
      S: getDate.getMilliseconds()
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (getDate.getFullYear() + '').substr(4 - RegExp.$1.length)
      )
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }
    return fmt
  },
  // 设置和修改cookie
  setCookie: (name, value, iDay) => {
    /* iDay 表示过期时间 name是设置cookie名称
    cookie中 = 号表示添加，不是赋值 */
    let oDate = new Date()
    oDate.setDate(oDate.getDate() + iDay)
    document.cookie = name + '=' + value + ';expires=' + oDate
  },
  // 获取cookie
  getCookie: name => {
    /* 获取浏览器所有cookie将其拆分成数组 */
    let arr = document.cookie.split('; ')

    for (let i = 0; i < arr.length; i++) {
      /* 将cookie名称和值拆分进行判断 */
      let arr2 = arr[i].split('=')
      if (arr2[0] === name) {
        return arr2[1]
      }
    }
    return ''
  },
  // 清空所有cookie;
  clearCookie () {
    let cookie = document.cookie
    let cookieArray = cookie.split('; ') // 将所有键值对分开
    let cookieKey = [] // 保存cookie中键值名的数组
    for (let i = 0; i < cookieArray.length; i++) {
      let keyValue = cookieArray[i].split('=')
      cookieKey[cookieKey.length] = keyValue[0] // 将对应的cookie的键存入数组中
    }
    for (let i = 0; i < cookieKey.length; i++) {
      this.setCookie(cookieKey[i], 1, -1) // 只要将cookie的保存日期设置为-1就可以清除kookie
    }
    console.log('已经成功清除所有cookie信息！')
  },
  insertScript (id, url) {
    const scriptData = scriptDataList.find(item => item.id === id)
    if (scriptData) {
      return scriptData.promise
    }
    const promise = new Promise(function (resolve, reject) {
      let el = document.getElementById(id)
      if (!el) {
        el = document.createElement('script')
        el.id = id
        el.type = 'text/javascript'
        el.src = url
        document.documentElement.appendChild(el)
      } else {
        resolve()
      }
      el.onload = function () {
        resolve()
      }
      el.onerror = function (msg) {
        reject(new Error(msg))
      }
    })
    scriptDataList.push({ id, promise })
    return promise
  },
  /**
   * 身份证号校验
   *
   *  */
  idCardValid (idCard) {
    const format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/
    // 号码规则校验
    if (!format.test(idCard)) {
      return false
    }
    // 区位码校验
    // 出生年月日校验  前正则限制起始年份为1900;
    let year = idCard.substr(6, 4) // 身份证年
    let month = idCard.substr(10, 2) // 身份证月
    let date = idCard.substr(12, 2) // 身份证日
    let time = Date.parse(month + '-' + date + '-' + year) // 身份证日期时间戳date
    let nowTime = Date.parse(new Date()) // 当前时间戳
    let dates = new Date(year, month, 0).getDate() // 身份证当月天数
    if (time > nowTime || date > dates) {
      return false
    }
    // 校验码判断
    const c = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2] // 系数
    const b = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'] // 校验码对照表
    const idArray = idCard.split('')
    let sum = 0
    for (let k = 0; k < 17; k++) {
      sum += parseInt(idArray[k]) * parseInt(c[k])
    }
    return idArray[17].toUpperCase() === b[sum % 11].toUpperCase()
  },
  /**
   * 转义HTML标签为纯文本
   * @param {String} html 原HTML标签字符串
   * @returns {String}
   */
  HTMLEncode (html) {
    let temp = document.createElement('div')
    temp.textContent != null
      ? (temp.textContent = html)
      : (temp.innerText = html)
    const output = temp.innerHTML
    temp = null
    return output
  },
  /**
   *@Description:手机号脱敏
   *@param {} {}
   *@return null
   */
  tellFormat (val) {
    if (typeof val !== 'string') return ''
    let valArray = val.split('')
    for (let i = 0; i < val.length; i++) {
      i > 2 && i < valArray.length - 4 && (valArray[i] = '*')
    }
    return valArray.join('')
  },
  /**
   *@Description:身份证脱敏
   *@param {} {}
   *@return null
  */
  cardNumberFormat (val) {
    if (typeof val !== 'string') return ''
    let valArray = val.split('')
    for (let i = 0; i < val.length; i++) {
      i < 14 && (valArray[i] = '*')
    }
    return valArray.join('')
  }
}
export default tools



// WEBPACK FOOTER //
// ./src/utils/Tools/index.js